import Runner from '@protonapp/proton-runner-rn0772'
import legacyRunner from '@protonapp/proton-runner'
import { withFeatureFlags } from '../flags'

export function getRunnerByReactNativeVersion(useNewReactNative) {
  if (useNewReactNative) {
    return withFeatureFlags(Runner)
  } else {
    return withFeatureFlags(legacyRunner)
  }
}
